<template>
    <span>
        <span v-if="criteria.lastName">{{criteria.lastName}} (Last name)</span>
        <span v-if="criteria.firstName">{{criteria.firstName}} (First name)</span>
        <span v-if="criteria.email">{{criteria.email}} (E-mail)</span>
        <template v-for="attr in otherAttrs">
            <span v-if="attr.value">{{attr.value}} ({{attr.category}})&nbsp;</span>
        </template>
</span>
</template>

<script type="javascript">

    export default {
        name: 'criteria-list',
        props: [
            'criteria'
        ],
        data() {
            return {
            };
        },
        computed: {
            otherAttrs() {
                const {
                    firstName, lastName, email, ...others
                } = this.criteria;
                return _.map(Object.keys(others), (key) => ({
                    category: key,
                    value: others[key]
                }));
            }
        }
    };
</script>
